import { SVGProps } from 'react';

export const CheckBold = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.47659 9.69365L0.589844 4.8069L2.45385 2.9429L5.47659 5.96564L11.1358 0.306396L12.9998 2.1704L5.47659 9.69365Z"
      fill="currentColor"
    />
  </svg>
);
